@if (visible) {
  <div
    class="custom-badge"
    [style.background-color]="backgroundColor"
    [matTooltip]="tooltipText"
    matTooltipShowDelay="50"
    matTooltipPosition="above"
    matTooltipHideDelay="100"
    >
    {{ badgeText }}
  </div>
}
